import { connect } from 'react-redux';
import actions from '../redux/actions/transaction_fee';
import TransactionFee from '../component/TransactionFee';

const mapStateToProps = (state) => ({
  coins: state.setting.coins,
  arrCoins: state.setting.arrCoins,
  limits: state.setting.cryptoLimitWithdrawal,
});

const mapDispatchToProps = (dispatch) => ({
  onChangeTransactionFeeAction: (params, callback) => {
    dispatch(actions.onUpdateTransactionFee(params, callback));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TransactionFee);
